<template>
  <div class="w-full flex md:items-center">
    <div class="flex-grow pr-10">
      <p class="truncate font-extrabold text-app-color">Invitation pending</p>
      <p class="opacity-70 text-14 truncate pr-20">{{ member.email }}</p>
    </div>
    <!-- SPACES -->
    <div class="w-150 flex relative" />

    <!-- ROLE -->
    <div class="w-full max-w-170">
      <TeamRolesSelect
        :disabled="isRegularUser"
        :role="role"
        @setRole="setRole"
      />
    </div>

    <!-- BILLING -->
    <div class="w-70 text-center" />

    <!-- DELETE -->
    <div class="w-100 text-center">
      <ButtonModule
        :disabled="!isAdmin"
        :has-hover="true"
        prefix="icon-delete text-main-color"
        class="text-app-color top-0 bottom-0 right-0 p-0"
        @click="deleteTemporaryMember"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

import { teamsService } from '@/services'

import TeamRolesSelect from '@/components/team/TeamRolesSelect'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: { TeamRolesSelect, ButtonModule },

  props: {
    member: Object
  },

  setup (props) {
    const { getters, dispatch } = useStore()
    const isDarkMode = computed(() => getters.isDarkMode)
    const isRegularUser = computed(() => getters.isRegularUser)
    const isAdmin = computed(() => getters.isAdmin)

    function deleteTemporaryMember () {
      teamsService.deleteTemporaryMember(props.member.id).then(() => dispatch('getTemporaryMembers'))
    }

    const role = computed(() => {
      return props.member?.teamRole?.name
    })

    function setRole (role) {
      dispatch('updateTempMemberRole', {
        id: props.member.id,
        role: role
      })
    }

    return {
      isDarkMode,
      role,
      isRegularUser,
      isAdmin,
      // functions
      setRole,
      deleteTemporaryMember
    }
  }
})
</script>
